/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { TypeRamp, sizes, Link } from '@smartsheet/lodestar-core';
import { ExternalIcon } from '@smartsheet/lodestar-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

const containerStyle = css`
  display: flex;
  justify-content: center;
  margin-top: ${sizes.xxLarge * 2 - 14}px;
  flex-direction: column;
  align-items: center;
`;

const titleStyle = css`
  width: 55%;
  text-align: center;
  margin: 0;
  margin-bottom: ${sizes.large}px;
`;

const linkContainerStyle = css`
  && {
    font-size: 15px;
    font-weight: 600;
  }
`;

const linkTextStyle = css`
  vertical-align: super;
  margin-right: ${sizes.xSmall}px;
`;

export const NoWorkflows = () => {
  const { t: translate } = useTranslation();
  return (
    <div css={containerStyle}>
      <TypeRamp variant="headerLarge" renderAs="h5" css={titleStyle}>
        {translate('designer:triggerPanel:parentWorkflow:noWorkflows')}
      </TypeRamp>
      <Link
        href="https://help.smartsheet.com/articles/2481996-use-child-workflows-to-manage-complex-processes"
        target="_blank"
        rel="noreferrer"
        css={linkContainerStyle}
      >
        <span css={linkTextStyle}>
          {translate('designer:triggerPanel:parentWorkflow:instructions')}
        </span>
        <ExternalIcon />
      </Link>
    </div>
  );
};
